let config = {
    METADATA_BASE_URL: 'metadata'
};

export default config;
